<template lang="pug">
.login-vue
    .login-third(v-if="pageData.enableThirdLogin")
        a.login-btn.google-login-btn(v-if='pageData.enableGoogleLogin' href="javascript:;")
          img(src="/static/img/google.png")
          | {{pageData.lang.loginThirdGoogle}}
        .login-or
            em {{pageData.lang.globalOr}}
    //login
    form.js-login(@submit.prevent="login()")
        .form-group
            label(for="username") {{pageData.lang.yourEmail}}
            input.form-control#username(v-model="form.username")
        .form-group
            label(for="password") {{pageData.lang.password}}
            input.form-control#username(v-model="form.password" type="password")
        .form-group(v-if="showAccessCode")
            label(for="accessCode") {{pageData.lang.globalAccessCode}}
            .row
                .col-8
                  input.form-control#accessCode(v-model="form.accessCode")
                .col-4
                  img.access-code(:src="defaultACode" @click="changeACode()")
        button.btn.btn-success.mt-1(:disabled="loading") {{pageData.lang.globalSignIn}}
        .alert.alert-danger.mt-1(v-if="errMsg!=''") {{errMsg}}

</template>
<script>
import $ from "jquery";
import qs from "qs";
export default {
  name: 'UserLogin',
  data() {
    return {
      pageData : {},
      loading : false,
      showAccessCode : false,
      defaultACode : "",
      errMsg : "",
      form :{
        username : "",
        password : "",
        accessCode : "",
        submit : 1,
      }
    }
  },
  beforeMount: function () {
      this.pageData = window.pageData;
      this.defaultACode = this.pageData.accessCodeUrl;
      var mThis = this;

      var handlerLogin = ga =>{
        $('.google-login-btn').click(function(){
          var googleUser = ga.signIn();
          googleUser.then(function(googleUser){
            var profile = googleUser.getBasicProfile();
            var id_token = googleUser.getAuthResponse().id_token;
            //to validate
            console.log('fasdfasdf',"asdfasdfasdf");
            $.post("/user/checkLoginToken.html" , {
              site : "google",
              token : id_token,
              id : profile.getId(),
              name : profile.getName(),
              face : profile.getImageUrl(),
              email : profile.getEmail(),
            } , res=>{
              if (res.errorCode != 0 ){
                  mThis.errMsg = res.msg;
                  return;
              }
              location.href = window.pageData.successUrl;
            }, "json");
          });
        });
      }
      window.googleInit = () => {
        gapi.load('auth2', () => {
          var googleAuth = gapi.auth2.init({
            client_id :  mThis.pageData.googleLoginId + '.apps.googleusercontent.com'
          });
          googleAuth.then(()=>{
            handlerLogin(googleAuth);
          });

        });
      }
  },

  methods : {
    changeACode: function(){
      this.defaultACode = this.pageData.accessCodeUrl + "&r=" + Math.random();
    },
    login: function(){
      var mThis = this;
      mThis.loading = true;
      mThis.errMsg = '';
      $.post("/user/login.html", qs.stringify(mThis.form) , function(ret){
        mThis.loading = false;

        if ( ret.errorCode != 0 ){
          mThis.errMsg = ret.msg.errMsg;
          if ( ret.msg.authCode ){
            mThis.showAccessCode = ret.msg.authCode;
          }
          mThis.changeACode();
          return;
        }
        $('.js-login-msg').hide();
        location.href = window.pageData.successUrl;
      },'JSON');

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/UserLogin.vue